// extracted by mini-css-extract-plugin
export default {"option":"product_option__Tu3jw","grp":"product_grp__u1009"};